import { KNOW_MORE, SEE_MORE } from '../home/locale';

export const TO_PDP = (isMobile?: boolean) => (isMobile ? SEE_MORE.toUpperCase() : KNOW_MORE);
export const MSG_FEEDBACK_SUCCESS = 'Ajouté avec succès !';
export const MSG_RETURN_TO_BASKET = 'Revenir au panier';
export const DATE_OF_SEND = `Date d'envoi`;
export const RECEIVER_EMAIL = 'Email du destinataire';
export const GIFT_CARD_DATE_ERROR = `La date doit être supérieure ou égale à aujourd'hui.`;
export const LBL_MESSAGE = 'Message';
